<template >
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="6">
          <h6 class="m-0">Informações do orçamento</h6>
        </d-col>
        <d-col cols="12" md="6" class="text-right">
          <quotation-buttons :quotation="model"></quotation-buttons>
        </d-col>
      </d-row>
    </d-card-header>

    <d-card-body class="d-flex flex-column">
      <d-form @submit.prevent="">
        <d-form-row>

          <!-- Budget number -->
          <d-col lg="6" xl="2" cols="12" class="form-group">
            <label for="feShippingCOmpany">Orçamento nº</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.reference_no" readonly/>
          </d-col>

          <!-- Customer -->
          <d-col lg="6" xl="6" cols="12" class="form-group">
            <label for="feShippingCOmpany">Cliente</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.customer_name" readonly/>
          </d-col>

          <!-- Customer City -->
          <d-col lg="6" xl="2" cols="12" class="form-group">
            <label for="feShippingCOmpany">Cidade</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.customer_city" readonly/>
          </d-col>

          <!-- Customer  State-->
          <d-col lg="6" xl="2" cols="12" class="form-group">
            <label for="feShippingCOmpany">Estado</label>
            <d-form-input type="text" id="feShippingCOmpany" v-model="model.customer_state" readonly/>
          </d-col>

        </d-form-row>

        <d-form-row>

          <!-- Valid at -->
          <d-col md="2" class="form-group">
            <label>Validade</label>
            <datepicker :model.sync="model.valid_at"/>
          </d-col>

          <!-- Seller -->
          <d-col md="2" class="form-group">
            <label>Vendedor</label>
            <select-seller :model.sync="model.created_by" v-if="isAdmin" ></select-seller>
            <d-form-input type="text" v-model="model.created_user.name" readonly v-else/>
          </d-col>

          <!-- Approved by -->
          <d-col v-if="model.approved_by" md="2" class="form-group">
            <label>Aprovado por</label>
            <label class="form-control">{{ model.approved_user.name }}</label>
          </d-col>

          <d-col :cols="model.approved_by ? '6' : '8'" class="form-group">
            <!-- Show payment -->
            <d-form-row  class="justify-content-end">
              <label class="mr-3">Exibir formas de pagamento</label>
              <d-checkbox toggle @change="toggleShowPayment()" :checked="showPayment" class="custom-toggle-sm mr-2">Sim</d-checkbox>
            </d-form-row>
            <!-- Show classes -->
            <d-form-row class="justify-content-end">
              <label class="mr-3">Exibir classes</label>
              <d-checkbox toggle @change="toggleShowClasses()" :checked="show_classes" class="custom-toggle-sm mr-2">Sim</d-checkbox>
            </d-form-row>
          </d-col>

          <!-- Show classes -->
          <d-col cols="12" class="form-group" v-if="show_classes">
            <d-form-row class="justify-content-end">
              <d-col cols="3" class="form-group" v-for="(col, id) in classes" :key="id">
                <label>{{ col.name }}</label>
                <d-select v-model="model.show_classes[id].pricing">
                  <option :value="null">Selecione...</option>
                  <option :value="option" v-for="(option, index) in col.pricing" :key="index">{{ option.mm }}mm</option>
                </d-select>
              </d-col>
            </d-form-row>
          </d-col>

        </d-form-row>

        <d-form-row>
          <d-col cols="12" class="form-group" v-if="model.groups">
            <groups-form ref="group" :groups.sync="model.groups" :state="groupsEmptyRow ? 'invalid' : 'valid' "/>
          </d-col>
        </d-form-row>

        <d-form-row>

          <!-- Companies -->
          <d-col md="6" class="form-group">
            <label>Empresa selecionada</label>
            <d-select
              class="form-control"
              v-model="model.company"
              text-field="label"
              value-field="data"
              :options="companies"
              @change="setCompany"
            >
            </d-select>
          </d-col>

          <!-- Company -->
          <d-col md="12" class="form-group" v-if="model.company_information">
            <editor :model.sync="model.company_information"/>
          </d-col>

        </d-form-row>

        <d-form-row>

          <!-- Signature -->
          <d-col md="3" class="form-group" v-for="(type, index) in signature" :key="type">
            <label>Assinatura: <small>{{type}}</small></label>
            <d-form-input type="text" :placeholder="type" v-model="model.signature[index]"/>
          </d-col>

        </d-form-row>

        <d-form-row>
          <d-col class="d-flex justify-content-end">
            <button class="btn btn-success" @click="save">Salvar</button>
            <button class="btn btn-success ml-4" @click="nextStep">Salvar e avançar</button>
          </d-col>
        </d-form-row>

      </d-form>
      <contractual-items-select-modal/>
      <import-modals/>
    </d-card-body>
    <import-modals/>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import GroupsForm from '_modules/quotation/components/GroupsForm.vue';
import Datepicker from '_shared/Datepicker.vue';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import SelectSeller from '_shared/SelectSeller.vue';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import ContractualItemsSelectModal from '_modules/quotation/components/modal/ContractualItemsSelectModal.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinValidateForm from '_common/mixins/ValidateForm';
import { cloneDeep, getDateTimeISO } from '_utils';
import QuotationActions from './QuotationActions';
import { CLASSES, PRICES } from '../../settings/components/SettingsModel';
import {
  ROW,
  MODEL,
  GROUP,
  SERVICE,
  SIGNATURE,
  _LOAD_MODEL_,
} from './QuotationModel';

export default {
  name: 'step-quotation-form',
  mixins: [MixinValidateForm, QuotationActions],
  components: {
    Editor,
    GroupsForm,
    Datepicker,
    ImportModals,
    SelectSeller,
    QuotationButtons,
    ContractualItemsSelectModal,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      items: [],
      show_classes: false,
      loading: false,
      signature: { ...SIGNATURE },
      selectedRowIndex: 0,
      groupsEmptyRow: null,
      errors: {},
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    showPayment() {
      return this.model.show_payments === 1;
    },
    companies: {
      get() {
        const { company } = this.$store.state.settings;
        if (company && company.informations.length) {
          return company.informations;
        }
        return [];
      },
      set(value) {
        return value;
      },
    },
    classes() {
      const { settings } = this.$store.state.settings;
      if (settings.quotationClass && settings.quotationClass.length) {
        return settings.quotationClass;
      }
      return { ...CLASSES.quotationClass };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
      'activeAlert',
      'getSettings',
      'getPaymentTypeOptions',
    ]),
    reorder(group) {
      group.rows.forEach((row, index) => {
        row.order = index;
        return row;
      });
    },
    cleanEmptyRows() {
      this.groupsEmptyRow = false;
      this.model.groups = this.model.groups.map(group => {
        group.rows = group.rows.filter(row => row.description);
        this.reorder(group);
        if (group.rows.length === 0) {
          this.groupsEmptyRow = true;
          group.rows.push(cloneDeep(ROW));
        }
        return group;
      });
    },
    formatDate() {
      this.model.valid_at = getDateTimeISO(this.model.valid_at);
      this.model.started_date = getDateTimeISO(this.model.started_date);
      this.model.delivery_date = getDateTimeISO(this.model.delivery_date);
    },
    getCompanies() {
      if (!this.$store.state.settings.companies) {
        this.setToggle({ type: 'progress', bool: true });
        this.getSettings()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          })
          .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }));
      }
    },
    nextStep() {
      if (this.save()) {
        this.$router.push({ name: 'admin-quotation-project', params: { quotationId: this.model.id } });
      }
    },
    save() {
      this.cleanEmptyRows();
      // const valid = this.$refs.group.checkRequiredFields();
      if (this.checkForm()) {
        this.formatDate();
        this.toggleLoading();
        this.model.step = 'quotation';
        return QuotationService.save(this.model)
          .then(response => this.success(response))
          .catch(error => {
            this.toggleLoading();
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
            return false;
          });
      }
      window.scrollTo(0, 0);
      this.activeAlert({ message: 'Erro de validação', theme: 'danger' });
      return false;
    },
    setCompany(value) {
      setTimeout(() => {
        this.model.company_information = value;
      }, 10);
    },
    success(quotation) {
      this.toggleLoading();
      this.activeAlert({ message: 'Orçamento salvo com sucesso', theme: 'success' });
      this.model = quotation;
      Events.$emit(_LOAD_MODEL_, quotation);
      this.$store.commit('setQuotation', quotation);
      return true;
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    loadModel(quotation) {
      if (quotation) {
        this.model = quotation;
      }
      if (this.model.model) {
        this.errors.model_name = { required: (this.model.model) };
        delete this.errors.customer_name;
      }
      if (!this.model.groups) {
        this.model.groups = cloneDeep(GROUP);
      }
      this.$refs.group.setObjectErrors();
      if (!this.model.signature) {
        this.model.signature = cloneDeep(SIGNATURE);
      }
      if (!this.model.service) {
        this.model.service = cloneDeep(SERVICE);
      }
      this.show_classes = this.model.show_classes !== null;
    },
    toggleShowPayment() {
      this.model.show_payments = (this.model.show_payments === 1) ? 0 : 1;
    },
    toggleShowClasses() {
      this.show_classes = !this.show_classes;
      if (this.show_classes && this.model.show_classes === null) {
        this.model.show_classes = cloneDeep(this.classes);
        this.model.show_classes.map(item => {
          item.pricing = { ...PRICES };
          return item;
        });
      } else {
        this.model.show_classes = null;
      }
    },
  },
  mounted() {
    const { quotation } = this.$store.state.quotation;
    this.loadModel(quotation);
    Events.$on(_LOAD_MODEL_, model => {
      this.loadModel(model);
    });
    this.checkAdmin();
    this.getCompanies();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}

</style>
<style lang="scss">
@import '~_scss/overrides';

.input-group.is-invalid {
  .input-group-prepend {
    .input-group-text {
      color: $red;
      border-color: $red;
    }
  }
}

.document {
  margin-left: 10px;
  font-weight: bold;
}
</style>
